/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'
import { apiResponseV4Schema } from './apiResponseV4Schema'
import { resendLoginCodeRequestV4Schema } from './resendLoginCodeRequestV4Schema'

export const authLoginResendCodeStatus200Schema = apiResponseV4Schema.describe(
  'V4 response envelope — same contract as the legacy EP.Models.ViewModels.ApiResponse minus the dead\r\n`planNeeded` field. V4 endpoints must never expose `planNeeded`; legacy endpoints keep\r\nthe old envelope untouched.'
)

export const authLoginResendCodeStatus400Schema = apiResponseV4Schema.describe(
  'V4 response envelope — same contract as the legacy EP.Models.ViewModels.ApiResponse minus the dead\r\n`planNeeded` field. V4 endpoints must never expose `planNeeded`; legacy endpoints keep\r\nthe old envelope untouched.'
)

export const authLoginResendCodeResponseSchema = authLoginResendCodeStatus200Schema

export const authLoginResendCodeErrorSchema = authLoginResendCodeStatus400Schema

export const authLoginResendCodeBodySchemaJsonPatchJson = resendLoginCodeRequestV4Schema

export const authLoginResendCodeBodySchemaJson = resendLoginCodeRequestV4Schema

export const authLoginResendCodeBodySchemaJson2 = resendLoginCodeRequestV4Schema

export const authLoginResendCodeBodySchemaJson3 = resendLoginCodeRequestV4Schema

export const authLoginResendCodeBodySchema = z.union([
  authLoginResendCodeBodySchemaJsonPatchJson,
  authLoginResendCodeBodySchemaJson,
  authLoginResendCodeBodySchemaJson2,
  authLoginResendCodeBodySchemaJson3,
])
